import React from 'react'
import { FloatingInspectorButton, FloatingInspectorButtonProps, MainText } from '../FloatingInspectorButton'
import { useTranslation } from 'react-i18next'

export interface FloatingInspectorButtonTextProps
  extends Pick<FloatingInspectorButtonProps, 'onClick' | 'selected' | 'disabled' | 'showArrow' | 'style' | 'tooltipText' | 'placementTooltip' | 'marginTooltip' | 'isSecondaryStyle' | 'popoverContent' | 'nonInteractive'> {
    text: string
    fontWeight?: number
}

const FloatingInspectorButtonText: React.FC<FloatingInspectorButtonTextProps> = ({ text, onClick, selected, disabled, showArrow, style, tooltipText, placementTooltip, marginTooltip, isSecondaryStyle, popoverContent, nonInteractive, fontWeight = 500 }) => {
  const [t] = useTranslation()
  return (
  <FloatingInspectorButton
    onClick={onClick}
    selected={selected}
    disabled={disabled}
    showArrow={showArrow}
    style={{
      padding: '4px 8px',
      ...style
    }}
    tooltipText={tooltipText}
    placementTooltip={placementTooltip}
    marginTooltip={marginTooltip}
    isSecondaryStyle={isSecondaryStyle}
    popoverContent={popoverContent}
    nonInteractive={nonInteractive}
  >
    <MainText $fontWeight={fontWeight}>{t(text)}</MainText>
  </FloatingInspectorButton>
)
}

export default FloatingInspectorButtonText